import React, { useState, useEffect, useRef } from "react";
import { Box, Button, Card, Divider, Grid, IconButton, Popover, TextField, Tooltip, Typography, styled, tooltipClasses } from "@mui/material";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { useDispatch, useSelector } from "react-redux";
import { openDialog, setData } from "../../features/dialogBox/dialogBoxSlice";
import ApiService from "../../utils/ApiService";
import Like from '../../../src/assets/images/like.svg'
import Mood from '../../../src/assets/images/mood.svg'
import Clapping from '../../../src/assets/images/clapping.svg'
import Favourite from '../../../src/assets/images/favourite.svg'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import encriptionHelper from '../../utils/encriptionHelper';
import { useLocation } from "react-router-dom";
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#2563EB',
    color: 'white',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));
const SingleCommentReaction = ({ feedPostComments, getUserReaction, feedPostData, indivisualAPI, formTransform, updateReaction, setSnackBar,
  selectedOption }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [anchorE4, setAnchorE4] = useState(null);
  const [throttleOptionClick, setThrottleOptionClick] = useState(false);
  const userData = useSelector((state) => state?.user?.userListName)
  const openPost = Boolean(anchorE4);
  const id = openPost ? 'simple-popover' : undefined;
  // const searchParams = encriptionHelper().decryptURLParams(window.location.search.substring(1).split("&")[0].split("=")[1]);
  const searchParams = location?.state || JSON.parse(localStorage.getItem("state"));
  const reactPost = searchParams['reactPost'] ?? location?.reactPost ?? 'reactPost';

  // ----------------- REACTIONS ICONS JSON --------------

  const reactionConfig = [
    { title: 'Like', icon: Like, action: 'Like' },
    { title: 'Applaud', icon: Clapping, action: 'Applaud' },
    { title: 'Love', icon: Favourite, action: 'Love' },
    { title: 'Curious', icon: Mood, action: 'Curious' }
  ];

  const handlePostClick = (event) => {
    setAnchorE4(event.currentTarget);
  };
  const handlePostClose = () => {
    setAnchorE4(null);
  };

  const handleReactionDialog = (post) => {
    dispatch(setData(post))
    dispatch(openDialog('reactionDialog'));
  }
  const handleOptionClick = (option) => {
    if (throttleOptionClick)
      return;
    setThrottleOptionClick(true);

    let reactionId = 4;

    if (option === 'Like') {
      reactionId = 1;
    } else if (option === 'Love') {
      reactionId = 2;
    } else if (option === 'Applaud') {
      reactionId = 3;
    }
    // deducing case for posting reaction, deleting reaction or changing reaction
    let caseHere = 'PUT';

    let findUserReaction = getUserReaction();

    if (findUserReaction == -1) {
      caseHere = "POST";
    } else if (findUserReaction.reactionId == reactionId) {
      caseHere = "DELETE";
    }

    let payload = { userId: userData?.userId, reactionId: reactionId, postId: feedPostData.id }
    if (reactPost != 'reactPost') {
      payload = { userId: userData?.userId, reactionId: reactionId, reactionType: feedPostData.type }
      payload[feedPostData.type + "Id"] = feedPostData.id;
      if (feedPostData.type == 'reward')
        payload['awardUserId'] = feedPostData.id;
      if (feedPostData.type == 'userWedding')
        payload['weddingId'] = feedPostData.id;
    }

    switch (caseHere) {
      case "POST": ApiService.post(reactPost, payload)
        .then((response) => {

          ApiService.get(indivisualAPI, {}, feedPostData.id).then((res) => {
            const data = [res.data.data].map(v => { return formTransform(v) })[0];
            // console.log(data)
            if (data) {
              updateReaction(data);
              setThrottleOptionClick(false);
            }

          })
            .catch((error) => {
              // console.error('Error:', error);
              setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
              setThrottleOptionClick(false);
            });
        })
        .catch((error) => {
          // console.error('Error:', error);
          setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
          setThrottleOptionClick(false);
        });
        break;
      case "DELETE": ApiService.delete(reactPost, { reactionId: reactionId }, reactPost == 'reactPost' ? findUserReaction.id : findUserReaction.pivot?.id)
        .then((response) => {
          ApiService.get(indivisualAPI, {}, feedPostData.id).then((res) => {
            const data = [res.data.data].map(v => formTransform(v))[0];
            // console.log(res.data.data)
            if (data) {
              updateReaction(data);
              setThrottleOptionClick(false);
              // setPostsData(post);
            }

          })
            .catch((error) => {
              setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
              setThrottleOptionClick(false);
            });
        })
        .catch((error) => {
          setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
          setThrottleOptionClick(false);
        }
        );
        break;
      case "PUT": ApiService.put(reactPost, { reactionId: reactionId }, reactPost == 'reactPost' ? findUserReaction.id : findUserReaction.pivot?.id)
        .then((response) => {
          ApiService.get(indivisualAPI, {}, feedPostData.id).then((res) => {
            const data = [res.data.data].map(v => formTransform(v))[0];
            if (data) {
              updateReaction(data);
              setThrottleOptionClick(false);
            }

          })
            .catch((error) => {
              setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
              setThrottleOptionClick(false);
            });
        })
        .catch((error) => {
          setSnackBar({ dataLoad: true, message: error.message, severity: 'error' });
          setThrottleOptionClick(false);
        });
        break;
      default: setThrottleOptionClick(false);
    }

    handlePostClose();
  };

  const showLikes = (post) => {
    if (!post?.reactionCount) {
      return (<></>)
    }

    let userName = post.post_reactions.filter(p => p.userId == userData.userId || p.pivot?.user_id == userData.userId).length ? 'You' : '';

    let reactions = post.post_reactions.reduce((prev, curr) => {
      let reactionId = curr.reactionId ?? curr.pivot?.reaction_id;
      if (prev.indexOf(parseInt(reactionId)) == -1) {
        prev.push(parseInt(reactionId))
      }
      return prev;
    }, []).sort();

    if (post.reactionCount == 1) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Box sx={{ mr: 1 }}>{showReaction(reactions)}</Box>
          <Box>
            <Typography variant="defineCaption" color="secondary.semiHeading2">
              {userName}
            </Typography>
          </Box>
        </Box>
      )
    }

    return (
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        fontSize: 'medium',
        wordBreak: 'break-word',
        '@media (min-width: 600px)': {
          flexDirection: 'row',
        },
      }}>
        <Box>{showReaction(reactions)}</Box>
        <Box sx={{
          display: 'flex',
          cursor: 'pointer',
          mb: 1,
          '&:hover span': { color: 'black' },
        }} onClick={() => handleReactionDialog(post)}>
          <Box>
            <Typography variant="defineCaption" color="secondary.semiHeading2">
              {userName.length ? userName + ' ' + 'and' + ' ' : ' '}
            </Typography>
          </Box>
          <Box sx={{ ml: 0.5 }}>
            <Typography variant="defineCaption" color="secondary.semiHeading2">
              {post.reactionCount - (userName.length ? 1 : 0)} Others
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }

  const showReaction = (reactions) => {
    return (
      <>
        {reactions.map(v => {
          switch (v) {
            case 1: return (<img src={Like} alt="Like" title="Like" key="Like" className='icon-size-1' />)
            case 2: return (<img src={Favourite} alt="Heart" title="Heart" key="Heart" className='icon-size-1' />)
            case 3: return (<img src={Clapping} alt="Applaud" title="Applaud" key="Applaud" className='icon-size-1' />)
            case 4: return (<img src={Mood} alt="Curious" title="Curious" key="Curious" className='icon-size-1' />)
          }
        })}
      </>)
  }
  return (
    <Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box>
              {showLikes(feedPostData)}
            </Box>
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Box>
              {feedPostComments && feedPostComments.length ? (
                <Button variant="text" sx={{ textTransform: 'unset !important' }}>
                  <Typography align='right' variant='body2' color='secondary'>{feedPostComments && feedPostComments.length} Comment{feedPostComments && feedPostComments.length !== 1 ? 's' : ''}</Typography>
                </Button>
              ) : (
                null
              )}

            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Divider />
      </Box>
      <Box>
        <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center' }}>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center">
              <Box mr={4}>
                <IconButton aria-describedby={id} onMouseEnter={handlePostClick}>
                  {selectedOption ? (
                    <>
                      {selectedOption === 1 && <Box sx={{ display: 'flex', alignItems: 'center' }}><Box sx={{ mr: 1 }}><img src={Like} alt="Like" title="Like" className='icon-size' /></Box><Box sx={{ mb: 0.5 }}><Typography variant='subtitle2' color='secondary'>Like</Typography></Box></Box>}
                      {selectedOption === 2 && <Box sx={{ display: 'flex', alignItems: 'center' }}><Box sx={{ mr: 1 }}><img src={Favourite} alt="Heart" title="Heart" className='icon-size' /></Box><Box sx={{ mb: 0.5 }}><Typography variant='subtitle2' color='secondary'>Love</Typography></Box></Box>}
                      {selectedOption === 3 && <Box sx={{ display: 'flex', alignItems: 'center' }}><Box sx={{ mr: 1 }}><img src={Clapping} alt="Applaud" title="Applaud" className='icon-size' /></Box><Box sx={{ mb: 0.5 }}><Typography variant='subtitle2' color='secondary'>Applaud</Typography></Box></Box>}
                      {selectedOption === 4 && <Box sx={{ display: 'flex', alignItems: 'center' }}><Box sx={{ mr: 1 }}><img src={Mood} alt="Curious" title="Curious" className='icon-size' /></Box><Box sx={{ mb: 0.5 }}><Typography variant='subtitle2' color='secondary'>Curious</Typography></Box></Box>}
                    </>
                  ) : (
                    <Box sx={{ display: 'flex', cursor: 'pointer' }}>
                      <Box sx={{ mr: 1 }}><ThumbUpOffAltIcon /></Box>
                      <Box><Typography variant='subtitle2' color='secondary'>Like</Typography></Box>
                    </Box>

                  )}
                </IconButton>
                <Popover
                  id={id}
                  open={openPost}
                  anchorEl={anchorE4}
                  onClose={handlePostClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                  <Box sx={{ p: 1, display: 'flex', alignItems: "center", cursor: 'pointer' }} onMouseLeave={handlePostClose}>
                    {reactionConfig.map((reaction, index) => (
                      <LightTooltip key={index} title={reaction.title} placement="top-end">
                        <Box
                          aria-label={reaction.title}
                          sx={{ mx: reaction.title === 'Applaud' || reaction.title === 'Curious' ? 1 : 0 }}
                          onClick={() => handleOptionClick(reaction.action)}
                        >
                          <img src={reaction.icon} alt={reaction.title} />
                        </Box>
                      </LightTooltip>
                    ))}
                  </Box>
                </Popover>
              </Box>
              <Box>
                <Button variant="text" color='secondary' startIcon={<ChatBubbleOutlineIcon color='secondary' />} sx={{ textTransform: 'unset !important', cursor: 'pointer' }}>
                  Comment
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SingleCommentReaction;
